var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 12.3084C8.22539 12.3084 6.77539 10.8667 6.77539 9.08337C6.77539 7.30003 8.22539 5.8667 10.0004 5.8667C11.7754 5.8667 13.2254 7.30837 13.2254 9.0917C13.2254 10.875 11.7754 12.3084 10.0004 12.3084ZM10.0004 7.1167C8.91706 7.1167 8.02539 8.00003 8.02539 9.0917C8.02539 10.1834 8.90872 11.0667 10.0004 11.0667C11.0921 11.0667 11.9754 10.1834 11.9754 9.0917C11.9754 8.00003 11.0837 7.1167 10.0004 7.1167Z",
    fill: "#093554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 19.4667C8.76706 19.4667 7.52539 19.0001 6.55872 18.0751C4.10039 15.7084 1.38372 11.9334 2.40872 7.44175C3.33372 3.36675 6.89206 1.54175 10.0004 1.54175C10.0004 1.54175 10.0004 1.54175 10.0087 1.54175C13.1171 1.54175 16.6754 3.36675 17.6004 7.45008C18.6171 11.9417 15.9004 15.7084 13.4421 18.0751C12.4754 19.0001 11.2337 19.4667 10.0004 19.4667ZM10.0004 2.79175C7.57539 2.79175 4.45872 4.08341 3.63372 7.71675C2.73372 11.6417 5.20039 15.0251 7.43372 17.1667C8.87539 18.5584 11.1337 18.5584 12.5754 17.1667C14.8004 15.0251 17.2671 11.6417 16.3837 7.71675C15.5504 4.08341 12.4254 2.79175 10.0004 2.79175Z",
    fill: "#093554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.28e20a44f88d54db7806c7c7de834b3d.svg";
export { ForwardRef as ReactComponent };